import { h, Component } from 'preact';
import dlv from 'dlv';

import { configure } from '../../../config';

import Error from '../error';
import { Desktop } from './device/desktop.js';
import { Tablet } from './device/tablet.js';
import { Phone } from './device/phone.js';

import { fetchArticleList } from '../../../lib/data';
import { fetchFromDailyMotionPlaylist } from '../../../lib/dailymotion';
import { COMMON_CONFIGS, setTheme } from '../../../lib/page';
import { trackPageLoad } from '../../../lib/tracking';
import { getPageConfig, isDesktop, getDeviceTemplate } from '../../../lib/device';
import { getLink } from '../../../lib/browse';

import { initializeTaboolaJs, finalizeTaboolaJs } from '../../pieces/taboola-js';

import { deviceVariance } from '@cube/blocks';
import { TrackingProvider, trackingProvider, DIMENSION } from '@cube/track';

const PER_PAGE = 20;

@trackingProvider({
	[DIMENSION.componentpath]: 'BrowsePage'
})
@configure({
	...COMMON_CONFIGS,
	pageConfig: 'singleCube.pages.browse',
	browseCategories: 'singleCube.browseCategories',
	clientDisplayName: 'clientDisplayName'
})
@deviceVariance()
export default class Browse extends Component {

	showMore = () => {
		window.location = getLink(this.props);
	};

	getAssets = (props) => {
		let hasVam = props.feed || props.vendor,
			vamCount = (hasVam ? (props.dmPlaylist ? PER_PAGE / 2 : PER_PAGE) : 0),
			dmCount = PER_PAGE - vamCount,
			offset = (props.page - 1) * vamCount;

		this.setState({
			hasMore: false,
			offset
		});

		if (props.dmPlaylist) {
			fetchFromDailyMotionPlaylist({ limit: dmCount, page: props.page, ...props }).then( res => {
				if (res.articles && res.articles.length > 0) {
					this.setState({
						assets: (this.state.assets || []).concat(res.articles),
						hasMore: this.state.hasMore || res.articles.length === dmCount
					});
				}
			});
		}

		if (vamCount > 0) {
			return fetchArticleList({
				count: vamCount,
				offset,
				imageSizes: 'w=256,h=144|w=300,h=169',
				...props }
			)
				.then( res => {
					if (res.articles && res.articles.length > 0) {
						this.setState({
							assets: res.articles.concat((this.state.assets || [])),
							hasMore: this.state.hasMore || res.articles.length === vamCount
						});
						return;
					}
				});
		}
	};

	processPageInformation = ({ category, browseCategories, vendor, ...props }) => {
		if (category) {
			let categoryConfig = browseCategories[category.toLowerCase()];
			if (!categoryConfig) {
				this.setState({
					assets: null,
					error: true,
					categoryConfig: {
						title: ''
					}
				});
				return;
			}

			this.setState({ categoryConfig });

			this.getAssets({ ...categoryConfig, ...props });
		}
		else if (vendor) {
			this.setState({
				categoryConfig: {
					title: vendor
				}
			});

			this.getAssets({ vendor, ...props });
		}
		else {
			this.setState({
				assets: null,
				error: true,
				categoryConfig: {
					title: ''
				}
			});
		}
	};

	static defaultProps = {
		page: 1
	};

	componentWillMount() {
		let device = this.props.device,
			pageConfig = getPageConfig(this.props.pageConfig, device);
		this.setState({ pageConfig, Device: getDeviceTemplate({ device, Desktop, Tablet, Phone }) });

		setTheme(pageConfig);
		this.processPageInformation(this.props);
		if (isDesktop(device)) {
			initializeTaboolaJs({ category: 'auto' });
		}
	}

	componentDidMount() {
		if (isDesktop(this.props.device)) {
			finalizeTaboolaJs();
		}

		trackPageLoad(this.context);
	}

	render( props, { Device, pageConfig, categoryConfig, assets, hasMore, error }) {

		if (error) return ( <Error /> );

		let hasAssets = assets && assets.length > 0;

		return (
			<TrackingProvider {...{ [DIMENSION.componentpath]: dlv(categoryConfig, 'title') }}>
				<Device
					categoryConfig={categoryConfig}
					assets={assets}
					hasMore={hasMore}
					error={error}
					hasAssets={hasAssets}
					showMore={this.showMore}
					{...props}
					pageConfig={pageConfig}
				/>
			</TrackingProvider>
		);
	}
}
